import React, { useState } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { SharingCodeErrorCode } from 'Enums';
import { useApiError, useCommercialApi } from 'Hooks';
import { Footer, Form, Input, Main, RichText, ScrollContainer, Spinner, TitleActionBar, } from 'Components/utility';
import { SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
const initialValues = {
    code: '',
    birthYear: '',
};
const MAX_LENGTH_CODE = 7;
const CommercialApiAddConnection = () => {
    const [loading, setLoading] = useState(false);
    const { sharingCodeValidate } = useCommercialApi();
    const { showApiErrorModal } = useApiError();
    const validationSchema = Yup.object().shape({
        code: Yup.string()
            .required(i18n.t('AddConnection.content.connectionFormFields.formField.code.errors.required'))
            .min(MAX_LENGTH_CODE, ''),
        birthYear: Yup.string()
            .required(i18n.t('AddConnection.content.connectionFormFields.formField.verifyBirthYear.errors.required'))
            .min(4, ''),
    });
    const displayMessageError = (modalProps) => {
        store.dispatch({
            type: SHOW_MODAL,
            modalProps: modalProps,
        });
    };
    const onSubmit = async (values) => {
        try {
            setLoading(true);
            const { errorCode, reachedMaxYobAttempts } = await sharingCodeValidate(values.code, Number(values.birthYear));
            if (!errorCode) {
                // TODO navigate to next step
                return;
            }
            switch (errorCode) {
                case SharingCodeErrorCode.CODE_NOT_FOUND:
                    displayMessageError({
                        header: i18n.t('AddConnection.modals.expiredCodeDialog.title'),
                        details: i18n.t('AddConnection.modals.expiredCodeDialog.body'),
                        testID: 'ExpiredCodeDialog',
                    });
                    break;
                case SharingCodeErrorCode.INVALID_YOB:
                case SharingCodeErrorCode.INCORRECT_YOB: {
                    if (reachedMaxYobAttempts) {
                        displayMessageError({
                            header: i18n.t('AddConnection.modals.requestNewCodeDialog.title'),
                            details: i18n.t('AddConnection.modals.requestNewCodeDialog.body'),
                            testID: 'RequestNewCodeDialog',
                        });
                        return;
                    }
                    displayMessageError({
                        details: (React.createElement(RichText, { text: i18n.t('AddConnection.modals.mismatchedBirthYearDialog.body'), testID: "AddConnection.modals.mismatchedBirthYearDialog.body" })),
                        testID: 'MismatchedBirthYearDialog',
                    });
                    break;
                }
                default:
                    showApiErrorModal();
            }
        }
        catch {
            showApiErrorModal();
        }
        finally {
            setLoading(false);
        }
    };
    const { handleSubmit, handleChange, handleBlur, isValid, errors, touched, values } = useFormik({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnBlur: true,
    });
    return (React.createElement(Main, null,
        React.createElement(TitleActionBar, { testID: "AddConnection", title: i18n.t('AddConnection.title') }),
        loading && React.createElement(Spinner, { testID: "Login" }),
        React.createElement(ScrollContainer, { marginTop: 0 },
            React.createElement(Form, null,
                React.createElement(Text, { testID: "AddConnection.subtitle", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default", color: "$text.100", marginBottom: "$2" }, i18n.t('AddConnection.subtitle')),
                React.createElement(Stack, null,
                    React.createElement(Input, { "aria-label": i18n.t('AddConnection.content.connectionFormFields.formField.code.label'), placeholder: i18n.t('AddConnection.content.connectionFormFields.formField.code.placeholder'), label: i18n.t('AddConnection.content.connectionFormFields.formField.code.label'), testID: "code", inputMode: "text", errorMessage: errors.code, isInvalid: errors.code && touched.code ? true : false, value: values.code, onChangeText: handleChange('code'), onBlur: handleBlur('code'), maxLength: MAX_LENGTH_CODE }),
                    React.createElement(Text, { testID: "AddConnection.formField.helpText", fontSize: "$bodySmall.default", fontWeight: "$bodySmall.default", color: "$text.60", marginTop: "$2", marginBottom: "$3" }, i18n.t('AddConnection.content.connectionFormFields.formField.code.helpText.uniqueCode')),
                    React.createElement(Input, { "aria-label": i18n.t('AddConnection.content.connectionFormFields.formField.verifyBirthYear.label'), placeholder: i18n.t('AddConnection.content.connectionFormFields.formField.verifyBirthYear.placeholder'), label: i18n.t('AddConnection.content.connectionFormFields.formField.verifyBirthYear.label'), testID: "birthYear", errorMessage: errors.birthYear, isInvalid: errors.birthYear && touched.birthYear ? true : false, value: values.birthYear, onChangeText: (e) => {
                            const handler = handleChange('birthYear');
                            return handler(e.replace(/[^0-9]/g, ''));
                        }, onBlur: handleBlur('birthYear'), inputMode: "numeric", maxLength: 4 })))),
        React.createElement(Footer, { buttonText: i18n.t('Global.microcopy.common.next'), onButtonSubmit: handleSubmit, testIDButton: "AddConnection.inviteConnection-btn", isButtonDisabled: !values.code || !values.birthYear || !isValid })));
};
export default CommercialApiAddConnection;
